import { createI18n } from 'vue-i18n';


export const language: any = {
  'en': require('@/i18n/locales/en-US.json'),
  'zh': require('@/i18n/locales/zh-CN.json'),
  'zh-tw': require('@/i18n/locales/zh-TW.json'),
  'id': require('@/i18n/locales/id-ID.json'),
};


/**
 * 检测浏览器语言并映射到支持的语言
 * @returns 支持的语言代码 'en' | 'zh' | 'zh-tw'
 */
const detectBrowserLanguage = (): string => {
  // 获取浏览器语言
  const browserLang = navigator.language || (navigator as any).userLanguage || 'en';
  const lang = browserLang.toLowerCase();
    console.log(lang);
  // 映射浏览器语言到支持的语言
  if (lang.startsWith('zh')) {
    // 判断是简体还是繁体
    // zh-tw, zh-HK, zh-MO 等视为繁体中文
    if (lang.includes('tw') || lang.includes('hk') || lang.includes('mo') || lang.includes('hant')) {
      return 'zh-tw';
    }
    // 其他中文视为简体中文
    return 'zh';
  }
  return lang || 'en';
}


export const defaultLang = detectBrowserLanguage()


// 从 localStorage 获取保存的语言
const savedLocale = localStorage.getItem('locale');

// 如果有保存的语言且支持，使用保存的语言；否则检测浏览器语言
let initialLocale: string;
if (savedLocale && language[savedLocale]) {
  initialLocale = savedLocale;
} else {
  // 自动检测浏览器语言
  initialLocale = detectBrowserLanguage();
  // 将检测到的语言保存到 localStorage，避免每次刷新都重新检测
  localStorage.setItem('locale', initialLocale);
}

const i18n = createI18n({
  legacy: false,              // 使用 composition API 的 useI18n
  globalInjection: true,   // 可在模板内直接使用 $t
  locale: initialLocale,
  fallbackLocale: defaultLang,
  messages: language
})

export default i18n
